import defaultTheme from './default'
const themes = {
  defaultTheme: defaultTheme
}
export default themes
